import {AxiosInstance} from "axios";
import Organization from "../model/organization/Organization";

/**
 * Api for organization data.
 */
export default class OrganizationApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Fetch base information about organization where belongs logged in user.
	 * @returns {Promise<Organization>}
	 */
	fetchOrganization(): Promise<Organization> {
		const url = '/api/web/organizations';
		return this.axiosInstance.get(url).then(resp => (Organization.fromJson(resp.data)))
	}
}
